<template>
	<div>
		<h2>兑换权益详情</h2>
		<el-form label-width="100px" label-position="left" style="width: 550px;">
			<el-form-item label="活动名称">
				<el-input v-model="sendData.name" style="width: 350px;"></el-input>
			</el-form-item>
			<el-form-item label="兑换类型">
				<el-tooltip class="item" effect="dark" content="只有新建计划才能修改类型" placement="top">
					<el-switch v-model="sendData.exchangeType" inactive-text="内部权益" active-text="外部权益"
						:disabled="$route.query.id!=null"></el-switch>
				</el-tooltip>
			</el-form-item>
			<el-form-item label="选择权益">
				<el-select v-model="sendData.memberDetailId" style="width: 200px;">
					<el-option v-for="item in typeList" :key="item.id" :value="item.id"
						:label="item.name + ':' + item.title">
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item v-if="sendData.exchangeType==true && $route.query.id==null" label="第三方券码">
				<div>
					<el-input type="textarea" v-model="codes" :autosize="{minRows:3,maxRows:18}" style="width:200px;">
					</el-input>
				</div>
			</el-form-item>
			<el-form-item v-if="!sendData.exchangeType" label="兑换码数量">
				<el-input-number v-model="sendData.total" size="small" style="width: 200px;"></el-input-number><span
					style="color: #333333;">最多生成100000个兑换码</span>
			</el-form-item>
			<el-form-item label="有效期">
				<el-switch v-model="sendData.expiredType" inactive-text="固定日期" active-text="领取后多少天到期"></el-switch>
				<div v-if="sendData.expiredType">
					<el-input-number type="num" size="small" v-model="sendData.day" style="width: 200px">
					</el-input-number>天
				</div>
				<div v-else>
					<el-date-picker type="datetimerange" v-model="time" end-placeholder="结束日期" start-placeholder="开始日期"
						value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
				</div>
			</el-form-item>
			<div class="flex" style="width: 100%;justify-content: center;">
				<el-button @click="back()">取消</el-button>
				<el-button type="primary" @click="save()">保存</el-button>
			</div>
		</el-form>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				sendData: {
					id: '',
					name: '',
					exchangeType: false,
					memberDetailId: 1,
					code: '',
					total: 0,
					expiredType: false,
					startTime: '', //开始时间
					endTime: '', //结束时间
					day: 0, //领取多少天后到期
				},
				typeList: [],
				time: [],
				codes: "",
				id: '',
			}
		},
		mounted() {
			this.getMemberDetail()
			if (this.$route.query.id != null) {
				this.id = this.$route.query.id
				this.getDetail()
			}
		},
		methods: {
			getDetail() {
				this.$http.get("dExchange/detail" + "?id=" + this.id).then(res => {
					this.sendData = res.body.data
					this.time.push(res.body.data.startTime)
					this.time.push(res.body.data.endTime)
				})
			},
			getMemberDetail() {
				this.$http.get("member/detail").then(res => {
					this.typeList = res.body.data
				})
			},
			save() {
				var s = this.sendData
				if (s.exchangeType) {
					let temp = this.codes.split("\n").map(ele => ele = ele.trim());
					s.code = temp.toString();
					s.total = temp.length;
				}
				if (this.time) {
					s.startTime = this.time[0]
					s.endTime = this.time[1]
				}
				var a = s
				this.$http.post("dExchange/save", JSON.stringify(a)).then(res => {
					if (res.body.code == 200) {
						this.$message.success("保存成功")
						this.$router.push("/exchange")
					}
				})
			},
			back() {
				this.$router.go(-1)
			},
		}
	}
</script>

<style>
	.flex {
		display: flex;
	}
</style>